import { render, staticRenderFns } from "./PlasticBadge.vue?vue&type=template&id=9e39377c&scoped=true&"
import script from "./PlasticBadge.vue?vue&type=script&lang=js&"
export * from "./PlasticBadge.vue?vue&type=script&lang=js&"
import style0 from "./PlasticBadge.vue?vue&type=style&index=0&id=9e39377c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e39377c",
  null
  
)

component.options.__file = "PlasticBadge.vue"
export default component.exports